import { PM2PrintFooterSlot, PM2PrintHeaderSlot } from '@provider/print';
import { units } from '@ui/css';
import { PageContext } from '../context.js';
import { ComponentDataProvider } from '../state/context.data.js';
import { PrintTaskChunk } from './chunk.task.js';
import { PrintOverviewPage } from './page.overview.js';
import { jsx } from 'react/jsx-runtime';

const pageCls = "_35sp1p7uxbe";
function makeOpgavekompleksetPrintSection(component) {
  return {
    pages: [{
      chunks: [{
        content: /*#__PURE__*/jsx(PageContext.Provider, {
          value: "print",
          children: /*#__PURE__*/jsx(ComponentDataProvider, {
            component: component,
            children: /*#__PURE__*/jsx(PrintOverviewPage, {})
          })
        })
      }],
      padding: () => ({
        top: units.px(18),
        bottom: units.px(25)
      })
    }, {
      className: pageCls,
      chunks: component.data.tasks
      // We omit infopages from the results, See ADO #114226
      .filter(task => task.type !== "task" || task.taskType !== "InfoPage").map((task, index) => ({
        content: /*#__PURE__*/jsx(PageContext.Provider, {
          value: "print",
          children: /*#__PURE__*/jsx(ComponentDataProvider, {
            component: component,
            children: /*#__PURE__*/jsx(PrintTaskChunk, {
              index: index,
              task: task
            }, task.id)
          })
        })
      })),
      padding: () => ({
        top: units.px(10),
        bottom: units.px(25)
      })
    }],
    config: {
      slots: {
        header: PM2PrintHeaderSlot,
        footer: PM2PrintFooterSlot
      },
      designSizeInPx: {
        width: 794,
        height: 1123
      }
    }
  };
}

export { makeOpgavekompleksetPrintSection };
import "./_make-print-section.linaria.module.css";
//# sourceMappingURL=_make-print-section.js.map
